import { FC } from 'react';
import { Flex } from '@chakra-ui/react';
import { AnimatePresence } from 'framer-motion';
import { ArcSpinner } from '../..';
export interface CbLoginSpinnerAnimationProps {
  animate: boolean;
}
export const CbLoginSpinnerAnimation: FC<CbLoginSpinnerAnimationProps> = ({
  animate
}) => {
  return <AnimatePresence data-sentry-element="AnimatePresence" data-sentry-component="CbLoginSpinnerAnimation" data-sentry-source-file="CbLoginSpinnerAnimation.tsx">
      <Flex aria-label="loading-spinner" alignItems="center" flexDirection="column" justifyContent="center" width="100%" position="absolute" top="42vh" data-sentry-element="Flex" data-sentry-source-file="CbLoginSpinnerAnimation.tsx">
        {animate && <ArcSpinner />}
      </Flex>
    </AnimatePresence>;
};